(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.EventsSummary.Referrals",
                    {
                        url: "/Referrals",
                        component: "referralsNew",
                        PageTitle: "Referrals | Marketing Tracker"
                    });
        }
    ]);

    app
        .component("referralsNew",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/EventsSummary/Referrals/referrals-new-template.html",
                controller: referralsNewController,
                bindings: {
                    year: "<",
                    user: "<",
                    onGetUserEvents: "&",
                    onGetDoughnuts: "&",
                    selectedEventType: "<"
                }
            });

    referralsNewController.$inject = ["$scope", "userApi", "_", "$filter"];
    function referralsNewController($scope, userApi, _, $filter) {
        var $ctrl = this;

        $scope.$on('selectedEventTypeChange', function (event, args) {
            $ctrl.ui.selectedEventType = args.selectedEventType;
            $ctrl.populatePageData();
        });

        $ctrl.ui = {};

        $ctrl.populatePageData = function () {

            $ctrl.TotalSpentOnEvents = 0;
            $ctrl.TotalInsuranceBusinessClosed = 0;
            $ctrl.TotalCommissionsGenerated = 0;
            $ctrl.TotalLeadsShowed = {};
            $ctrl.TotalAppointmentsSet = {};
            $ctrl.TotalKeptAppointments = {};
            $ctrl.TotalClosedAppointments = {};
            $ctrl.Reservations = {};
            $ctrl.Attendees = {};
            $ctrl.Invites = 0;
            $ctrl.TotalKeptAppointments.Referrals = 0;
            $ctrl.TotalKeptAppointments.Clients = 0;
            $ctrl.TotalKeptAppointments.Prospects = 0;
            $ctrl.TotalKeptAppointments.Total = 0;
            $ctrl.TotalAppointmentsSet.Referrals = 0;
            $ctrl.TotalAppointmentsSet.Clients = 0;
            $ctrl.TotalAppointmentsSet.Prospects = 0;
            $ctrl.TotalAppointmentsSet.Total = 0;
            $ctrl.TotalClosedAppointments.Referrals = 0;
            $ctrl.TotalClosedAppointments.Clients = 0;
            $ctrl.TotalClosedAppointments.Prospects = 0;
            $ctrl.TotalClosedAppointments.Total = 0;
            $ctrl.TotalLeadsShowed.Referrals = 0;
            $ctrl.TotalLeadsShowed.Clients = 0;
            $ctrl.TotalLeadsShowed.Prospects = 0;
            $ctrl.TotalLeadsShowed.Total = 0;
            $ctrl.Attendees.Referrals = 0;
            $ctrl.Attendees.Clients = 0;
            $ctrl.Attendees.Prospects = 0;
            $ctrl.Attendees.Total = 0;
            $ctrl.Reservations.Referrals = 0;
            $ctrl.Reservations.Clients = 0;
            $ctrl.Reservations.Prospects = 0;
            $ctrl.Reservations.Total = 0;
            $ctrl.stats = {};

            userApi.getFigAuth($ctrl.user.Id).then(function (figAuthUser) {
                $ctrl.onGetUserEvents({
                    figAuthUserId: figAuthUser.FigAuthUserId
                }).then(function (groups) {
                    ng.forEach(_.uniqBy(groups, function (row) { return row.Id; }),
                        function (row) {                            
                            //if (row.CommunicationMedium === 'Live' || !row.CommunicationMedium) //only caculate Live (Webinars and others may be calculated differently, TBD) -Removing check for now per Monica B
                                assignValues(_.find(groups, function (g) { return row.Id === g.Id; }));
                        });
                    $ctrl.stats.responseRate = $ctrl.Invites > 0
                        ? ($ctrl.Reservations.Referrals /
                            $ctrl.Invites) *
                        100
                        : 0;
                    if ($ctrl.stats.responseRate < 0) $ctrl.stats.responseRate = 0;
                    $ctrl.responseRate = $ctrl.onGetDoughnuts({ num: $ctrl.stats.responseRate });

                    $ctrl.stats.noShowRate = $ctrl.Reservations.Referrals > 0
                        ? (($ctrl.Reservations.Referrals - $ctrl.Attendees.Referrals) / $ctrl.Reservations.Referrals) *
                        100
                        : 0;
                    if ($ctrl.stats.noShowRate < 0) $ctrl.stats.noShowRate = 0;
                    $ctrl.noShowRate = $ctrl.onGetDoughnuts({ num: $ctrl.stats.noShowRate });

                    $ctrl.stats.appointmentSettingRate =
                        $ctrl.TotalLeadsShowed.Referrals > 0
                            ? ($ctrl.TotalAppointmentsSet.Referrals /
                                $ctrl.TotalLeadsShowed.Referrals) *
                            100
                            : 0;
                    if ($ctrl.stats.appointmentSettingRate < 0) $ctrl.stats.appointmentSettingRate = 0;
                    $ctrl.appointmentSettingRate = $ctrl.onGetDoughnuts({ num: $ctrl.stats.appointmentSettingRate });

                    $ctrl.stats.persistencyRate =
                        $ctrl.TotalAppointmentsSet.Referrals > 0
                            ? ($ctrl.TotalKeptAppointments.Referrals /
                                $ctrl.TotalAppointmentsSet.Referrals) *
                            100
                            : 0;
                    if ($ctrl.stats.persistencyRate < 0) $ctrl.stats.persistencyRate = 0;
                    $ctrl.persistencyRate = $ctrl.onGetDoughnuts({ num: $ctrl.stats.persistencyRate });

                    $ctrl.stats.closeRate =
                        $ctrl.TotalKeptAppointments.Referrals > 0
                            ? ($ctrl.TotalClosedAppointments.Referrals /
                                $ctrl.TotalKeptAppointments.Referrals) *
                            100
                            : 0;
                    if ($ctrl.stats.closeRate < 0) $ctrl.stats.closeRate = 0;
                    $ctrl.closeRate = $ctrl.onGetDoughnuts({ num: $ctrl.stats.closeRate });

                    $ctrl.stats.roi = $ctrl.TotalSpentOnEvents > 0
                        ? (($ctrl.TotalCommissionsGenerated - $ctrl.TotalSpentOnEvents) / $ctrl.TotalSpentOnEvents) *
                        100
                        : 0;
                    if ($ctrl.stats.roi < 0) $ctrl.stats.roi = 0;
                    $ctrl.roi = $ctrl.onGetDoughnuts({ num: $ctrl.stats.roi });
                });
            });
        };

        function assignValues(r) {
            if (r.AppointmentsKept) {
                $ctrl.TotalKeptAppointments.Referrals += r.AppointmentsKept.Referrals;
                $ctrl.TotalKeptAppointments.Clients += r.AppointmentsKept.Clients;
                $ctrl.TotalKeptAppointments.Prospects += r.AppointmentsKept.Prospects;
                $ctrl.TotalKeptAppointments.Total += r.AppointmentsKept.Referrals + r.AppointmentsKept.Clients + r.AppointmentsKept.Prospects;
            }
            if (r.AppointmentsSet) {
                $ctrl.TotalAppointmentsSet.Referrals += r.AppointmentsSet.Referrals;
                $ctrl.TotalAppointmentsSet.Clients += r.AppointmentsSet.Clients;
                $ctrl.TotalAppointmentsSet.Prospects += r.AppointmentsSet.Prospects;
                $ctrl.TotalAppointmentsSet.Total += r.AppointmentsSet.Referrals + r.AppointmentsSet.Clients + r.AppointmentsSet.Prospects;
            }
            if (r.AppointmentsClosed) {
                $ctrl.TotalClosedAppointments.Referrals += r.AppointmentsClosed.Referrals;
                $ctrl.TotalClosedAppointments.Clients += r.AppointmentsClosed.Clients;
                $ctrl.TotalClosedAppointments.Prospects += r.AppointmentsClosed.Prospects;
                $ctrl.TotalClosedAppointments.Total += r.AppointmentsClosed.Referrals + r.AppointmentsClosed.Clients + r.AppointmentsClosed.Prospects;
            }
            if (r.UnitsAttended) {
                $ctrl.TotalLeadsShowed.Referrals += r.UnitsAttended.Referrals;
                $ctrl.TotalLeadsShowed.Clients += r.UnitsAttended.Clients;
                $ctrl.TotalLeadsShowed.Prospects += r.UnitsAttended.Prospects;
                $ctrl.TotalLeadsShowed.Total += r.UnitsAttended.Referrals + r.UnitsAttended.Clients + r.UnitsAttended.Prospects;
            }
            if (r.Attendees) {
                $ctrl.Attendees.Referrals += r.Attendees.Referrals;
                $ctrl.Attendees.Clients += r.Attendees.Clients;
                $ctrl.Attendees.Prospects += r.Attendees.Prospects;
                $ctrl.Attendees.Total += r.Attendees.Referrals + r.Attendees.Clients + r.Attendees.Prospects;
            }
            if (r.Reservations) {
                $ctrl.Reservations.Referrals += r.Reservations.Referrals;
                $ctrl.Reservations.Clients += r.Reservations.Clients;
                $ctrl.Reservations.Prospects += r.Reservations.Prospects;
                $ctrl.Reservations.Total += r.Reservations.Referrals + r.Reservations.Clients + r.Reservations.Prospects;
            }
            $ctrl.Invites += r.Invites;
            $ctrl.TotalCommissionsGenerated += r.TotalCommission;
            $ctrl.TotalSpentOnEvents += r.TotalEventCost;
            $ctrl.TotalInsuranceBusinessClosed += r.TotalInsuranceBusinessClosed;
        }
    }

})(window.app, window.angular); //jshint ignore:line